import { Snapshot } from '../shared/snapshot';

export class DashboardSnapshot implements DashboardSnapshotModel {
    id: number;
    name: string;
    description: string;
    abbreviation: string;
    isDefault: boolean;
    isGlobal: boolean;
    isShared: boolean;
    privilege: 'EDIT' | 'VIEW';
    createdBy: string;
    createdDate: string;
    iconClass: 'global' | 'private' | undefined;

    constructor(init: DashboardSnapshotModel) {
        this.id = init.id;
        this.name = init.name;
        this.description = init.description;
        this.abbreviation = init.abbreviation;
        this.isDefault = !!init.isDefault;
        this.isGlobal = init.isGlobal;
        this.isShared = init.isShared;
        this.privilege = init.privilege;
        this.createdBy = init.createdBy;
        this.createdDate = init.createdDate;

        this.iconClass = this.deriveIconClass();
    }

    deriveIconClass(): 'global' | 'private' | undefined {
        if (this.isGlobal) {
            return 'global';
        }

        if (!this.isShared) {
            return 'private';
        }

        return undefined;
    }
}

export interface DashboardSnapshotModel extends Snapshot {
    abbreviation: string;
    isDefault?: boolean;
}
